<template>
  <nav class="nav-bar">
    <!-- <a href="/" class="navbar-brand">
      <img class="nav-logo" src="../../img/eflexLogo.png" alt="EFLEX Logo" />
    </a> -->
    <div class="nav-bar-links">
      <li class="nav-bar-item">
        <a
          href="/dashboardDSO"
          :class="
            getRoute.includes('/dashboard')
              ? 'nav-bar-link first nav-bar-link-active'
              : 'nav-bar-link first'
          "
          >Dashboard</a
        >
      </li>
      <li class="nav-bar-item">
        <a
          href="/assetsLite"
          :class="
            getRoute.includes('/asset')
              ? 'nav-bar-link nav-bar-link-active'
              : 'nav-bar-link'
          "
          >Assets</a
        >
      </li>
      <li class="nav-bar-item">
        <a
          href="/offersLite"
          :class="
            getRoute.includes('/offer')
              ? 'nav-bar-link nav-bar-link-active'
              : 'nav-bar-link'
          "
          >Offers</a
        >
      </li>
      <li class="nav-bar-item">
        <a
          href="/requests"
          :class="
            getRoute.includes('/request')
              ? 'nav-bar-link nav-bar-link-active'
              : 'nav-bar-link'
          "
          >Requests</a
        >
      </li>
      <li class="nav-bar-item">
        <a
          href="/consumption"
          :class="
            getRoute.includes('/consumption')
              ? 'nav-bar-link nav-bar-link-active'
              : 'nav-bar-link'
          "
          >Consumption</a
        >
      </li>
      <li class="nav-bar-item">
        <a
          href="/buypart1"
          :class="
            getRoute.includes('/buy')
              ? 'nav-bar-link nav-bar-link-active'
              : 'nav-bar-link'
          "
          >Buy</a
        >
      </li>
      <li class="nav-bar-item">
        <a
          href="/summary"
          :class="
            getRoute.includes('/summary')
              ? 'nav-bar-link nav-bar-link-active'
              : 'nav-bar-link'
          "
          >Summary</a
        >
      </li>
      <li class="nav-bar-item nav-bar-item-last">
      </li>
    </div>
  </nav>
</template>

<script>
import { mdiAccountCircle } from "@mdi/js";
export default {
  data() {
    return {
      icons: {
        mdiAccountCircle,
      },
    };
  },
  computed: {
    getRoute() {
      return this.$route.fullPath;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.nav-bar {
  display: flex;
  height: 50px;
  padding: 0 20px;
  background: #253858;
  border-bottom: 1px solid #172235;
  /* margin-top: -100px;
  margin-left: -10px; */
}

.nav-bar-links {
  display: flex;
  width: 100%;
}

.nav-bar-item {
  list-style: none;
}

.nav-logo {
  width: 150px;
  margin-right: 10px;
}

.nav-bar-link,
.nav-bar-link-active {
  font-size: 0.9em;
  margin-left: 50px;
  letter-spacing: 1.2px;
  position: relative;
}

.first {
  margin-left: 0;
}

.nav-bar-link {
  color: rgba(255, 255, 255, 0.8);
}

.nav-bar-link-active {
  color: #fff;
}

.nav-bar-link:before,
.nav-bar-link-active:before {
  width: 0;
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 3px;
  height: 2px;
  background: $green;
  -webkit-transition: 0.15s linear;
  transition: 0.15s linear;
}

.nav-bar-link:hover {
  color: #fff;
  text-decoration: none;
}

.nav-bar-link:hover:before,
.nav-bar-link-active:before {
  width: 100%;
}

.nav-bar-item-last {
  margin-left: auto;
  margin-top: 5px;
  cursor: pointer
}
</style>
